import { useState, useMemo, useRef, useEffect } from "react"
import { useRequest } from "ahooks";
import { Card, Button, Modal, Select, Input, Form, message } from "antd";
import { Table, DEFAULT_PAGE_DATA } from "../../../components/table";
import { generateTableColumns } from "./config";
import { CardServer } from "../../../server";
import { EditForm } from "../../../components/editForm";

const server = CardServer.VipCardTask

export const VipCardTask = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });
    const [addModalVisible, setAddModalVisible] = useState<any>(false);
    const [form] = Form.useForm();
    const [cardProductList, setCardProductList] = useState<any[]>([]);
    const [selectedCardProductId, setSelectedCardProductId] = useState<any>('');

    // 初始化加载数据
    useEffect(() => {
        fetchProductList()
    }, []);
    //获取表格数据
    const { run, refresh } = useRequest(server.list, {
        defaultParams: [{ ...pageData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });
    // 获取卡片产品id列表
    const fetchProductList = async () => {
        const data = await server.cardProductList({});
        setCardProductList(data);
    };
    const getTableColumns = useMemo(() => {
        return generateTableColumns({ loading });
    }, [loading]);
    
    // 添加卡片弹窗相关逻辑
    const handleAddCard = () => {
        setAddModalVisible(true);
    };
    
    const handleAddOk = async (values: any) => {
        if (!values.cardProductId) {
            message.warning('请选择选卡产品id');
            return;
        }
        if (!values.cardProductId) {
            message.warning('请输入卡片数量');
            return;
        }
        // 调用后端API
        const response = await server.create({
            CardProductId: values.cardProductId,
            Number: Number(values.number),
        });
        if (response) {
            message.success('创建成功');
            setAddModalVisible(false);
            form.resetFields();
            run({...pageData, Page: 1})
        }
    };
    const handleAddCancel = () => {
        form.resetFields();
        setAddModalVisible(false);
    };

    return (
        <div>
            <Card className="mt20">
                <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button type="primary" onClick={handleAddCard}>
                    新建
                    </Button>
                </div>
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage });
                    }}
                />
            </Card >
            {/* 新增 */}
            <Modal
                title="创建虚拟vip卡任务"
                visible={addModalVisible}
                onCancel={handleAddCancel}
                onOk={() => form.submit()}
                okText="确认"
                cancelText="取消"
            >
                <Form
                form={form}
                layout="vertical"
                onFinish={handleAddOk}
                autoComplete="off"
                >
                <Form.Item
                    label="卡产品id"
                    name="cardProductId"
                    rules={[{ required: true, message: '请选择卡产品id' }]}
                >
                    <Select placeholder="请选择卡产品id"
                        value={selectedCardProductId}
                        onChange={id => setSelectedCardProductId(id)}
                        options={cardProductList.map(t => ({
                            value: t.Id,
                            label: t.UdpayCardBin
                        }))}
                    />
                </Form.Item>

                <Form.Item
                    label="卡片数量"
                    name="number"
                    rules={[
                    { required: true, message: '请输入卡片数量' },
                    ]}
                >
                    <Input placeholder="请输入卡片数量" />
                </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}